import { useEffect, useState } from 'react';
import TransactionBatchService from '../../../services/transactionBatchService';

export const useFetchTransactionBatches = ({ organizationId, propertyId }) => {
  const [transactionBatches, setTransactionBatches] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    // $FlowFixMe
    const abortController = new AbortController(); // eslint-disable-line
    const fetchTransactionBatches = async () => {
      setIsLoading(true);
      const transactionBatchService = new TransactionBatchService();
      const response = await transactionBatchService.getAllTransactionBatches(
        organizationId,
        propertyId,
        abortController.signal,
      );

      setTransactionBatches(response);
      setIsLoading(false);
    };
    if (organizationId && propertyId) fetchTransactionBatches();

    return () => abortController.abort();
  }, [organizationId, propertyId]);

  return { transactionBatches, isLoading };
};
